import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Link } from 'foundations-components/transitional/components/Link';
// @ts-expect-error Could not find a declaration file for module
import { setAttribute } from 'MeetingsAdmin/redux/actions/UserAttributesActions';
// @ts-expect-error Could not find a declaration file for module
import { getUserId } from 'MeetingsAdmin/selectors/AuthSelector';
import UsageTracker from 'MeetingsAdmin/tracking/UsageTracker';
// @ts-expect-error Could not find a declaration file for module
import { getHasPaymentLinksReadAccess } from 'MeetingsAdmin/selectors/AccessSelector';
import { MEETINGS_USER_VIEWED_PAYMENT_BANNER } from 'MeetingsAdmin/constants/userAttributeKeys';
import { useDefaultPaymentsAccountDetails } from 'MeetingsAdmin/hooks/usePaymentsAccountEligibility';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getPaymentLinksUrl, getPaymentSettingsUrl } from '../../utils/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PaidMeetingsBanner() {
  const [paymentLinkHoverTracked, setPaymentLinkHoverTracked] = useState(false);
  const dispatch = useDispatch();
  const userId = useSelector(state => getUserId(state));
  const hasPaymentLinksReadAccess = useSelector(getHasPaymentLinksReadAccess);
  const {
    data
  } = useDefaultPaymentsAccountDetails();
  const paymentsEligbilityChargesEnabled = !!(data !== null && data !== void 0 && data.getDefaultPaymentsAccountDetails.capabilities.canTransact);
  const paymentsUrl = paymentsEligbilityChargesEnabled && hasPaymentLinksReadAccess ? getPaymentLinksUrl() : getPaymentSettingsUrl();
  const handleClosePaidMeetingsBanner = () => {
    dispatch(setAttribute({
      userId,
      key: MEETINGS_USER_VIEWED_PAYMENT_BANNER,
      value: 'true'
    }));
  };
  const trackPaymentLinkHover = () => {
    if (!paymentLinkHoverTracked) {
      UsageTracker.track('paymentMerchant', {
        action: 'payment-banner-CTA-hovered'
      });
      setPaymentLinkHoverTracked(true);
    }
  };
  const trackPaymentLinkClick = () => {
    UsageTracker.track('paymentMerchant', {
      action: 'payment-banner-CTA-clicked'
    });
  };
  return /*#__PURE__*/_jsxs(Alert, {
    closeable: true,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "calendarView.banner.paidMeetings.titleText"
    }),
    onClose: handleClosePaidMeetingsBanner,
    marginBlockEnd: "300",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "calendarView.banner.paidMeetings.body"
    }), ' ', /*#__PURE__*/_jsx(Link, {
      onMouseEnter: trackPaymentLinkHover,
      onClick: trackPaymentLinkClick,
      href: paymentsUrl,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "calendarView.banner.paidMeetings.learnMore"
      })
    })]
  });
}